export var REWARD_CARD_LAYOUT = {
  // Title slot reserves 2 lines. Short titles render in line 1 only and leave
  // line 2 empty — but the slot height stays fixed so the subtitle below
  // always starts at the same Y. Titles longer than 2 lines ellipsize, which
  // matches the ticket's "split into two lines" expectation.
  titleLines: 2,
  // Both the categories subtitle and the offers price share the same 2-line
  // slot height so the total content stack — and therefore the title baseline
  // — matches between the two card types. Offers price content (icon + value)
  // renders top-aligned on line 1; line 2 stays empty.
  subtitleLines: 2,
  priceLines: 2,
  // Multiplied by the corresponding font size to get the line height in px.
  titleLineHeightFactor: 1.25,
  subtitleLineHeightFactor: 1.3,
  priceLineHeightFactor: 1.3,
  // Multiplied by cardHeight.
  interSlotGapFactor: 0.022,
  // Multiplied by cardWidth — keeps the text band visually centered inside
  // the artwork frame on both phone and tablet artwork variants.
  descriptionWidthFactor: {
    tablet: 0.704,
    phone: 0.663
  },
  // Multiplied by cardHeight — anchors the wrapper to the bottom of the
  // dark backing area of the artwork. Lower value pushes the whole text
  // block down toward the bottom of the band so the title sits more
  // visually centered (mobile only — web uses its own flex layout).
  descriptionBottomFactor: {
    tablet: 0.025,
    phone: 0.010
  }
};

// Mobile helper: computes every absolute number needed for the description
// wrapper. Web cannot use this directly because its sizes are CSS-driven, but
// it reuses REWARD_CARD_LAYOUT and applies the same multipliers in CSS.
export var buildRewardCardTypography = function buildRewardCardTypography(_ref) {
  var cardWidth = _ref.cardWidth,
    cardHeight = _ref.cardHeight,
    variant = _ref.variant,
    titleFontSize = _ref.titleFontSize,
    subtitleFontSize = _ref.subtitleFontSize,
    priceFontSize = _ref.priceFontSize;
  var L = REWARD_CARD_LAYOUT;
  var titleLineHeight = titleFontSize * L.titleLineHeightFactor;
  var subtitleLineHeight = subtitleFontSize * L.subtitleLineHeightFactor;
  var priceLineHeight = priceFontSize * L.priceLineHeightFactor;
  var titleSlotHeight = titleLineHeight * L.titleLines;
  var subtitleSlotHeight = subtitleLineHeight * L.subtitleLines;
  var priceSlotHeight = priceLineHeight * L.priceLines;
  var interSlotGap = cardHeight * L.interSlotGapFactor;
  var descriptionWidth = cardWidth * L.descriptionWidthFactor[variant];
  var descriptionLeft = (cardWidth - descriptionWidth) / 2;
  var descriptionWrapperBottom = cardHeight * L.descriptionBottomFactor[variant];
  return {
    title: {
      fontSize: titleFontSize,
      lineHeight: titleLineHeight,
      slotHeight: titleSlotHeight,
      lines: L.titleLines
    },
    subtitle: {
      fontSize: subtitleFontSize,
      lineHeight: subtitleLineHeight,
      slotHeight: subtitleSlotHeight,
      lines: L.subtitleLines
    },
    price: {
      fontSize: priceFontSize,
      lineHeight: priceLineHeight,
      slotHeight: priceSlotHeight,
      lines: L.priceLines
    },
    interSlotGap: interSlotGap,
    descriptionWidth: descriptionWidth,
    descriptionLeft: descriptionLeft,
    descriptionWrapperBottom: descriptionWrapperBottom,
    categoriesWrapperHeight: titleSlotHeight + interSlotGap + subtitleSlotHeight,
    offersWrapperHeight: titleSlotHeight + interSlotGap + priceSlotHeight
  };
};